import { EVENT_DATE, EVENT_NAME, toWhatsAppUrl } from './format';

export function referralTokenFromLocation(): string | null {
  const content = new URLSearchParams(window.location.search).get('utm_content') ?? '';
  return content.startsWith('ref_') ? content.slice(4) : null;
}

export function referralRegistrationUrl(token?: string): string {
  const site = (import.meta.env.VITE_PUBLIC_SITE_URL || window.location.origin).replace(/\/$/, '');
  const url = new URL('/inscricao', `${site}/`);
  url.searchParams.set('utm_source', 'indicacao');
  url.searchParams.set('utm_medium', 'whatsapp');
  url.searchParams.set('utm_campaign', 'forteens_12h');
  url.searchParams.set('utm_content', token ? `ref_${token}` : 'page_share');
  return url.toString();
}

export function referralWhatsAppUrl(token?: string): string {
  const link = referralRegistrationUrl(token);
  return toWhatsAppUrl(`Bora viver o ${EVENT_NAME} comigo? Dia ${EVENT_DATE}. Sua vaga começa aqui: ${link}`);
}
